export default __webpack_public_path__ + "static/media/02.40c1825b.jpg";